import { combineReducers } from "redux";
import { authDetailReducer } from "./authDetail/reducers";
import { alertMessageReducer } from "./alertMessage/reducers";
import { commonListReducer } from "./commonlist/reducers";
import { shortCutReducer } from "./shortCut/reducers";
import { userPermissionReducer } from "./permission/reducers";
import { reloadNotification } from "./ReloadNotification/reducers";
import toggleReducer from "./balanceShow/toggleReducer"; // Import the new toggle reducer
import formResetReducer from './formReset/formResetReducer';
import editReducer from './editState/editReducer'; // Import the new edit reducer

const reducers = combineReducers({
  authDetail: authDetailReducer,
  alertMessage: alertMessageReducer,
  commonList: commonListReducer,
  shortCut: shortCutReducer,
  userPermission: userPermissionReducer,
  reloadNotification: reloadNotification,
  toggle: toggleReducer, // Add the toggle reducer here
  formReset: formResetReducer,
  editState: editReducer, // Add the edit reducer here
});

export default reducers;